import i18n from 'i18next';
import React, {useEffect, useMemo, useState} from 'react';
import {
	ComponentUtils,
	DetailActionType,
	OrganizationSelection,
	SwDetail,
	SwForm,
	get,
	DetailActions,
	SwPagination
} from 'simplifyworks-core-ui';
import {connect} from 'react-redux';
import {getEavFields} from '../../utils/eav';
import {bindActionCreators} from 'redux';
import {FOEDUS_ROLE} from '../../domain/constants';

const OrganizationDetail = (props) => {
	const isNew = props.params.id === 'new';

	// Definicie eav poli
	const [allOrganizationFieldsDefinitions, setAllOrganizationFieldsDefinitions] = useState(null);

	useEffect(() => {
		get('/api/core/field-definitions/CoreOrganization',
			(result) => {
				setAllOrganizationFieldsDefinitions(result);
			}
		);
	}, []);

	const newCallback = (type, id) => {
		if (type === DetailActionType.DETAIL_CREATE_SUCCESS && id) {
			props.router.push('/contacts/organizations/' + id);
		}
	};

	useEffect(() => {
		if (props?.loggedUserCountry) {
			props.actions.detail.formInit(
				'/api/ood/entries/new',
				props.foundFormKeyForCountry,
				null,
				null,
				{
					organization: {
						active: true,
						structureType: 'ORG',
						organizationType: props?.nationalBodyCoreCodebook,
						organization: props?.loggedUserCountry
					}
				}
			);
		}
	}, [props?.loggedUserCountry]);

	const logoOrganizationFieldDefinition = useMemo(() => {
		return allOrganizationFieldsDefinitions?.find(ofd => ofd?.key === 'logo');
	}, [allOrganizationFieldsDefinitions]);

	const webOrganizationFieldDefinition = useMemo(() => {
		return allOrganizationFieldsDefinitions?.find(ofd => ofd?.key === 'web');
	}, [allOrganizationFieldsDefinitions]);

	const phoneOrganizationFieldDefinition = useMemo(() => {
		return allOrganizationFieldsDefinitions?.find(ofd => ofd?.key === 'phone');
	}, [allOrganizationFieldsDefinitions]);

	const faxOrganizationFieldDefinition = useMemo(() => {
		return allOrganizationFieldsDefinitions?.find(ofd => ofd?.key === 'fax');
	}, [allOrganizationFieldsDefinitions]);

	const emailOrganizationFieldDefinition = useMemo(() => {
		return allOrganizationFieldsDefinitions?.find(ofd => ofd?.key === 'email');
	}, [allOrganizationFieldsDefinitions]);

	const otherOrganizationFieldsDefinitions = useMemo(() => {
		return allOrganizationFieldsDefinitions?.filter(ofd => {
			const usedFieldDefinitions = [logoOrganizationFieldDefinition, webOrganizationFieldDefinition, phoneOrganizationFieldDefinition, faxOrganizationFieldDefinition, emailOrganizationFieldDefinition];
			return !usedFieldDefinitions.some(ufd => ufd?.key === ofd?.key);
		}) ?? [];
	}, [allOrganizationFieldsDefinitions]);

	return <>
		<SwDetail
			rest='/api/foedus/contacts/organizations'
			restId={props.params?.id}
			newCallback={newCallback}
			exitPath='/contacts/organizations'
			tabName={props?.params?.tabName}
			disabled={props?.isReadOnly}
		>
			<SwPagination listName={'foedus-contacts-organizations-list'} />
			<SwForm
				rest='base-info'
				labelKey='core-organization'
				new={isNew}
				labelKeyPrefix='core-organization'
				tabName='base-info'
				initialValue={{
					organization: {
						active: true,
						structureType: 'ORG',
						organizationType: props?.nationalBodyCoreCodebook,
						organization: props?.loggedUserCountry
					}
				}}>
				<SwForm.Section>
					{getEavFields(
						logoOrganizationFieldDefinition ? [logoOrganizationFieldDefinition] : [],
						'organization'
					)}
					<SwForm.String
						size={4}
						property='organization.name'
						labelKey='core-organization-name'
						validations='required;lengthRange(1,255)'
					/>
					<SwForm.String
						size={2}
						property='organization.code'
						labelKey='core-organization-abbreviation'
						validations='required;lengthRange(1,50)'
					/>

					<SwForm.String
						size={9}
						property='organization.place'
						validations='length(255)'
						labelKey='core-organization-place'
					/>
					<SwForm.Entity
						size={3}
						property='organization.organization'
						labelKey='foedus-country'
						render={OrganizationSelection.renderText}
						disabled={props?.loggedUserPrimaryFoedusRole !== FOEDUS_ROLE.ADMIN}
						validations='required'
					>
						{OrganizationSelection.renderSelectionExtended({
							name: 'core-organization-organization',
							excludeUsed: true
						})}
					</SwForm.Entity>

					{getEavFields(
						webOrganizationFieldDefinition ? [webOrganizationFieldDefinition] : [],
						'organization',
						4
					)}

					{getEavFields(
						phoneOrganizationFieldDefinition ? [phoneOrganizationFieldDefinition] : [],
						'organization',
						8
					)}

					{getEavFields(
						faxOrganizationFieldDefinition ? [faxOrganizationFieldDefinition] : [],
						'organization',
						4
					)}

					{getEavFields(
						emailOrganizationFieldDefinition ? [emailOrganizationFieldDefinition] : [],
						'organization',
						8
					)}

					<SwForm.String
						size={12}
						property='organization.note'
						validations='length(255)'
						labelKey='foedus-additionalInfo'
					/>

					{/*// Pre pripad, ze niekto v buducnosti prida eav field pumpou a bude sa cudovat preco sa nezobrazil*/}
					{getEavFields(
						otherOrganizationFieldsDefinitions,
						'organization'
					)}

				</SwForm.Section>
				<SwForm.Section>

				</SwForm.Section>
			</SwForm>

		</SwDetail>
	</>;
};

const mapStateToProps = (state, ownProps) => {
	const organizationDetailFormData = ComponentUtils.getFormData(state, '/api/foedus/contacts/organizations/' + ownProps.params.id, 'base-info');

	const getIsReadOnly = () => {
		// Foedus admin moze editovat vsetkych
		if (state?.security?.allRoles?.includes(FOEDUS_ROLE.ADMIN)) {
			return false;
		}

		// Ak sa jedna o organizaciu, ktora spada pod krajinu country managera
		if (state?.security?.allRoles?.includes(FOEDUS_ROLE.COUNTRY_MANAGER)) {
			if (state?.foedus?.loggedUserCountry?.id === organizationDetailFormData?.organization?.organization?.id) {
				return false;
			}
		}

		return true;
	};

	return {
		formData: organizationDetailFormData,
		nationalBodyCoreCodebook: state?.foedus?.nationalBodyCoreCodebook,
		countryCoreCodebook: state?.foedus?.countryCoreCodebook,
		loggedUserCountry: state?.foedus?.loggedUserCountry,
		loggedUserPrimaryFoedusRole: state?.foedus?.loggedUserPrimaryFoedusRole,
		isAdmin: state?.security?.allRoles?.includes('admin'),
		isReadOnly: getIsReadOnly()
	};
};

const mapDispatchToProps = (dispatch) => ({
	actions: {
		detail: bindActionCreators(DetailActions, dispatch)
	}
});

export default {
	title: () => i18n.t('foedus-contacts-organizations-title-detail'),
	main: connect(mapStateToProps, mapDispatchToProps)(OrganizationDetail)
};
